// extracted by mini-css-extract-plugin
module.exports = {"side-bar":"Sidebar_side-bar__2Mssk","edge-logo":"Sidebar_edge-logo__1uqul"};